import Vue from 'vue';
import layout from './layout';

Vue.directive('layout', layout);